import React from 'react';
import api from '../api';
import { createMuiTheme, makeStyles, MuiThemeProvider, Paper, Tabs, Tab, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import edit from '../../assets/1@3x.png';
import EditJadwalPoli from './editJadwalPoli';
import ic_detail from '../../assets/ic_detail.png';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

export default function DetailJadwalPoli() {
    const before_cron = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:50`)
    const year_cron = before_cron.getFullYear()
    const date_cron = before_cron.getDate() < 10 ? `0${before_cron.getDate()}` : before_cron.getDate()
    const month_cron = before_cron.getMonth() + 1 < 10 ? `0${before_cron.getMonth() + 1}` : before_cron.getMonth() + 1
    const time_cron = 23
    const created = `${year_cron}-${month_cron}-${date_cron}`
    const location = useLocation()
    const efDate = location.state.efDate
    const datum = location.state.detailSchedule.effective_date
    const refresh = location.state.refresh
    const id = location.state.id
    console.log(refresh);
    const [value, setValue] = React.useState([])
    const [val, setVal] = React.useState([])
    // let val;
    console.log(val);
    console.log(location);
    // datum.map(el => {
    //     console.log(el);
    //     if (el.date === efDate) {
    //         val = el
    //     }
    // })
    console.log(val, '---------------');
    const history = useHistory()
    const classes = useStyles()
    const [jadwal, setJadwal] = React.useState([]);
    const [list, setList] = React.useState([])
    const [visibleEdit, setVisibleEdit] = React.useState(false)
    const [isEdit, setIsEdit] = React.useState(false)
    const [sentData, setSentData] = React.useState([])
    // const [value, setValue] = React.useState([])

    React.useEffect(() => {
        getDetailPoli(id)
    },[])

    const getDetailPoli = (id) => {
        api.create().getPoliSchedule(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let temp = []
                    response.data.data[0].effective_date.map((el, idx) => {
                        if (el.date === efDate) {
                            setVal(el)
                        }
                    })
                }
            }
            // if (response.data.data != false) {
            //     let temp = []
            //     response.data.data[0].effective_date.map((item, idx) => {
            //         console.log(item);
            //         item["no"] = idx + 1
            //         item["created_at"] = el.created_at
            //         item["updated_at"] = el.updated_at
            //         temp.push(item)
            //     })
            //     setDetailSchedule(response.data.data[0])
            //     console.log(response.data.data[0]);
            //     setValue(temp)
                
            // } else {
            //     setValue([])
            // }
        })
    }

    const handleSeeDetail = (e, bool) => {
        console.log(e);
        setIsEdit(bool)
        setSentData(e.rowData)
        setVisibleEdit(true)
    }

    const onClose = () => {
        setVisibleEdit(false)
    }

    const columns = [
        {
            name: "hari",
            label: "Hari"
        },
        {
            name: "time_start",
            label: "Waktu Mulai Periksa"
        },
        {
            name: "time_end",
            label: "Waktu Selesai Periksa"
        }, 
        {
            name: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    let timeData = new Date(tableMeta.rowData[5])
                    let dateData = timeData.getDate() < 10 ? `0${timeData.getDate()}` : timeData.getDate()
                    let monthData = timeData.getMonth() + 1 < 10 ? `0${timeData.getMonth() + 1}` : timeData.getMonth() + 1
                    let yearData = timeData.getFullYear()
                    let waktu = timeData.getHours() < 10 ? `0${timeData.getHours()}` : timeData.getHours()
                    let b = `${yearData}-${monthData}-${dateData}`
                    return (
                        <div style={{ display: 'flex' }}>
                            <button
                                onClick={() => {
                                    if (created === b && waktu < time_cron) {
                                        handleSeeDetail(tableMeta, true)
                                    } else {
                                        handleSeeDetail(tableMeta, false)
                                    }
                                }}
                                title={created === b && waktu < time_cron ? "Edit" : "Detail"}
                                style={{
                                    backgroundColor: "transparent",
                                    // borderRadius: 70,
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                    {
                                        created === b && waktu < time_cron ?
                                        <img src={edit} style={{width: 36, height: 36}} />
                                        :
                                        <img src={ic_detail} style={{width: 36, height: 36}} />
                                    }
                            </button>
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "created_at",
            options: {
                display: false,
                filter: false
            }
        },
    ];

    const handleClick = (el) => {
        console.log(el);
        setJadwal(el)
        setValue(el.effective_date[0])
    }

    const handleChange = (e) => {
        console.log(e);
        setValue(e)
    }
    console.log(list);
    console.log(jadwal);
    console.log(value);
    return (
            <div style={{ paddingTop: 20, marginTop: -20 }}>
            <Typography style={{color: '#a4a4a4', fontSize: 15, position: 'absolute', zIndex: 2, top: 100}}>Klinik {location.state.sentData.name.toUpperCase()}</Typography>
                <div style={{marginTop: 20}}>
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={val.schedule}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                                    
                </div>
                {visibleEdit ?
                    <EditJadwalPoli
                        onClose={onClose}
                        detail={sentData}
                        efDate={efDate}
                        isEdit={isEdit}
                        refresh={() => getDetailPoli(id)}
                    />
                    : null
                }
            </div>
    )
}